export function formatNumber(number: number): string {
  if (typeof number !== "number") {
    console.log("Input must be a number");
  }

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
}

export function formatNumberWithDigit(number: number | string): string {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(number));
}

export const formatToTwoDecimals = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '0.00';

  const num =
    typeof value === 'string'
      ? Number(value.replace(/,/g, ''))
      : value;

  return isNaN(num) ? '0.00' : num.toFixed(2);
};
